export default __webpack_public_path__ + "static/media/bg-slider.e1391154.webp";